function generateAutoResizeScript(targetOrigin: string = '*'): string {
  return `
(function() {
  let lastHeight = 0;
  let resizeTimer = null;
  let observers = [];
  let intervalId = null;
  let isVisible = true;

  function resizeIframe() {
    if (!isVisible) return;

    try {
      const height = document.body.scrollHeight;
      if (height !== lastHeight) {
        lastHeight = height;
        window.parent.postMessage(
          { type: 'embed-resize', height: height },
          '${targetOrigin}'
        );
      }
    } catch (e) {
      console.error('Resize error:', e);
    }
  }

  function debouncedResize() {
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(resizeIframe, 250);
  }

  function cleanup() {
    observers.forEach(o => {
      try {
        o.disconnect();
      } catch (e) {
        console.error('Observer disconnect error:', e);
      }
    });
    observers = [];

    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }

    if (resizeTimer) {
      clearTimeout(resizeTimer);
      resizeTimer = null;
    }
  }

  function setupObservers() {
    if (window.ResizeObserver) {
      try {
        const resizeObserver = new ResizeObserver(debouncedResize);
        resizeObserver.observe(document.body);
        observers.push(resizeObserver);
      } catch (e) {
        console.error('ResizeObserver error:', e);
      }
    }

    if (window.MutationObserver) {
      try {
        const mutationObserver = new MutationObserver(debouncedResize);
        mutationObserver.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
        observers.push(mutationObserver);
      } catch (e) {
        console.error('MutationObserver error:', e);
      }
    }

    if (window.IntersectionObserver) {
      try {
        const intersectionObserver = new IntersectionObserver(
          function(entries) {
            isVisible = entries[0].isIntersecting;
            if (isVisible) {
              debouncedResize();
            }
          },
          { threshold: 0 }
        );
        intersectionObserver.observe(document.body);
        observers.push(intersectionObserver);
      } catch (e) {
        console.error('IntersectionObserver error:', e);
      }
    }
  }

  setTimeout(resizeIframe, 0);

  window.addEventListener('load', debouncedResize);

  document.addEventListener('load', function(e) {
    if (e.target && e.target.tagName && (e.target.tagName === 'IMG' || e.target.tagName === 'IFRAME')) {
      debouncedResize();
    }
  }, true);

  window.addEventListener('beforeunload', cleanup);

  setupObservers();

  if (!window.ResizeObserver && !window.MutationObserver) {
    intervalId = setInterval(debouncedResize, 1000);
  }
})();
`.trim();
}

export function wrapContentWithAutoResize(content: string, targetOrigin: string = '*'): string {
  return `<!DOCTYPE html>
<html style="height: 100%; width: 100%;">
<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
  <meta charset="utf-8">
  <style>
    * {
      box-sizing: border-box;
    }
    body, body * {
      max-width: 100%;
    }
  </style>
  <script>
${generateAutoResizeScript(targetOrigin)}
  </script>
</head>
<body style="margin: 0; padding: 0; width: 100%; overflow-x: hidden; overflow-y: auto;">
${content}
</body>
</html>`;
}
